import CustomButton from "../../../../../UIElements/CustomButton";
import { Box, Typography } from "@mui/material";

export default function SucessSubmitDossierContent({
    onSucessSubmitDossier,
    text,
}: {
    onSucessSubmitDossier: Function;
    text?: string;
}) {
    const textSuccess =
        text && text.length > 0 ? text : "Votre avis a été enregistré !";
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Typography
                sx={{
                    alignSelf: "stretch",
                    color: "#005499",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "1.75rem",
                    fontQtyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                }}
            >
                {textSuccess}
            </Typography>
            <CustomButton
                onClick={() => {
                    onSucessSubmitDossier();
                }}
                label="Terminer"
                customsx={{
                    width: "100%",
                }}
            />
        </Box>
    );
}
